
import { TransformGroup, PlottableModel, Annotation, Transform, Project, Job, MapHelper} from '4d-mapper';
import { BaseEvent, BaseSimpleEvent } from 'vasat/dist/src/veflux';

/**
 * Abstract represntation of a coordnate both in 3d space on screen space
 */
export interface Coordinate {
  latitude:number
  longitude:number
  height?:number

  screenPosition:{
    x:number
    y:number
  };
}

/**
 * Implemented by any componet that wants control of the maps click events
 */
export interface ClickHandler {
  /**
   * returns true if the click was handled, otherwise the other items in the stack will be run
   * 
   * @param position r
   * @param feature 
   * @param isRightClick 
   */
   onMapClicked(position:Coordinate,feature:PlottableModel<any>,isRightClick:boolean) : boolean
}


/**
 * representation of the cursor, fired on the MapEvent.cursorStream when changed.
 * This item is a memory only object and can carry data via its 'meta' field. It is typicaly set by a clickHandler, 
 * though it could be set by anything else too.
 */
export class Cursor{
  constructor(public coodinate:Coordinate,public icon?:string,public meta?:any ){}
}


export class ProjectEvent extends BaseEvent<Project,'loaded'|'loading'|'unloaded'|'fetched'|'unfetched'|'changed'|'deleted'>{}

/**
 * Specific event for scene changes
 */
export class SceneEvent extends BaseEvent<TransformGroup,'loaded'|'loading'|'unloaded'|'fetched'|'unfetched'|'deleted'|'changed'|'transform_added'|'transform_removed'|'photo_added'|'photo_removed'|'photo_removed_all'>{}


/**
 * Specific event for layers changes
 */
export class LayerEvent extends BaseSimpleEvent<Transform>{}

/**
 * Specific event for photos
 */
export class PhotoEvent extends BaseSimpleEvent<Transform>{}

/**
 * Specific event for photos
 */
export class AnnotationEvent extends BaseSimpleEvent<Annotation>{}

/**
 * Specific event for cursor changes
 */
export class CursorEvent extends BaseSimpleEvent<Cursor>{}
/**
 * Specific event for map
 */
export class MapEvent extends BaseSimpleEvent<MapHelper>{}

/**
 * Specific event for map
 */
export class CameraEvent extends BaseEvent<CameraDirection|PlottableModel<any>,'request_move'|'moved'|'start_move'>{}

export class JobEvent extends BaseEvent<Job,'processing'|'processing_finished'|'processing_error'|'uploading'|'upload_error'|'upload_finished'|'selected'|'unselected'>{}


export interface SyncAgent{
  id:string,
  agent:'dropbox'|'google_drive'
  targetFolder?:number
  name:string,
  size:number,
  isDir:boolean
}
/**
 * Specific events from drobbox syncs etc
 */
export class SyncAgentEvent extends BaseSimpleEvent<SyncAgent>{}

/**
 * TODO
 */
export interface CameraDirection {
  position:Coordinate
  heading:number
  pitch:number
  roll:number
}